import { render, staticRenderFns } from "./MatchHockeyResult.vue?vue&type=template&id=6896a108&scoped=true&"
import script from "./MatchHockeyResult.vue?vue&type=script&lang=js&"
export * from "./MatchHockeyResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896a108",
  null
  
)

export default component.exports